import React from 'react';
import {
  Typography,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import OperationResume from '../OperationResume';

const ProductSelector = (props: any) => {
  const { business, selectedDocuments, productType, setProductType } = props;
  return (
    <div>
      <OperationResume
        stakeholderName={business.businessName}
        stakeholderIdentifier={business.identifier}
        documents={selectedDocuments}
      />
      <Divider />
      <div style={{ padding: '20px 0px' }}>
        <Typography variant="h6">Selecciona el tipo de producto</Typography>
        <FormControl margin="dense" fullWidth>
          <InputLabel id="product-type-label">Tipo de producto</InputLabel>
          <Select
            labelId="product-type-label"
            id="product-type-select"
            fullWidth
            value={productType}
            onChange={(e) => setProductType(e.target.value)}
            label="Tipo de producto"
          >
            <MenuItem value="traditional">Tradicional</MenuItem>
            {/* <MenuItem value="earlyPayment">Pronto pago</MenuItem> */}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default ProductSelector;
